module.exports = __webpack_public_path__ + "media/images/landing__teaser__bg-5212f7c4287ab25a750ac5e472ce090f.jpg";